// ##############################
// // // IconButton styles
// #############################

import {
	grayColor,
	roseColor,
	primaryColor,
	infoColor,
	successColor,
	warningColor,
	dangerColor,
} from "../material-dashboard-react.js";

const iconButtonStyle = {
	button: {
		height: "40px",
		minWidth: "40px",
		width: "40px",
		borderRadius: "50%",
		fontSize: "24px",
		margin: "auto",
		padding: "0",
		boxShadow:
			"0 2px 2px 0 rgba(153, 153, 153, 0.14), 0 3px 1px -2px rgba(153, 153, 153, 0.2), 0 1px 5px 0 rgba(153, 153, 153, 0.12)",
		overflow: "hidden",
		position: "relative",
		lineHeight: "normal",
		border: "none",
		fontWeight: "400",
		textTransform: "uppercase",
		letterSpacing: "0",
		willChange: "box-shadow, transform",
		transition:
			"box-shadow 0.2s cubic-bezier(0.4, 0, 1, 1), background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
		display: "inline-block",
		textAlign: "center",
		whiteSpace: "nowrap",
		verticalAlign: "middle",
		touchAction: "manipulation",
		cursor: "pointer",
		userSelect: "none",
		backgroundImage: "none",
		backgroundColor: grayColor[0],
		"&:hover": {
			backgroundColor: grayColor[0],
			boxShadow:
				"0 14px 26px -12px rgba(153, 153, 153, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(153, 153, 153, 0.2)",
		},
	},
	primary: {
		backgroundColor: primaryColor[0],
		boxShadow:
			"0 2px 2px 0 rgba(156, 39, 176, 0.14), 0 3px 1px -2px rgba(156, 39, 176, 0.2), 0 1px 5px 0 rgba(156, 39, 176, 0.12)",
		"&:hover": {
			backgroundColor: primaryColor[0],
			boxShadow:
				"0 14px 26px -12px rgba(156, 39, 176, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(156, 39, 176, 0.2)",
		},
	},
	info: {
		backgroundColor: infoColor[0],
		boxShadow:
			"0 2px 2px 0 rgba(0, 188, 212, 0.14), 0 3px 1px -2px rgba(0, 188, 212, 0.2), 0 1px 5px 0 rgba(0, 188, 212, 0.12)",
		"&:hover": {
			backgroundColor: infoColor[0],
			boxShadow:
				"0 14px 26px -12px rgba(0, 188, 212, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 188, 212, 0.2)",
		},
	},
	success: {
		backgroundColor: successColor[0],
		boxShadow:
			"0 2px 2px 0 rgba(76, 175, 80, 0.14), 0 3px 1px -2px rgba(76, 175, 80, 0.2), 0 1px 5px 0 rgba(76, 175, 80, 0.12)",
		"&:hover": {
			backgroundColor: successColor[0],
			boxShadow:
				"0 14px 26px -12px rgba(76, 175, 80, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(76, 175, 80, 0.2)",
		},
	},
	warning: {
		backgroundColor: warningColor[0],
		boxShadow:
			"0 2px 2px 0 rgba(255, 152, 0, 0.14), 0 3px 1px -2px rgba(255, 152, 0, 0.2), 0 1px 5px 0 rgba(255, 152, 0, 0.12)",
		"&:hover": {
			backgroundColor: warningColor[0],
			boxShadow:
				"0 14px 26px -12px rgba(255, 152, 0, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(255, 152, 0, 0.2)",
		},
	},
	danger: {
		backgroundColor: dangerColor[0],
		boxShadow:
			"0 2px 2px 0 rgba(244, 67, 54, 0.14), 0 3px 1px -2px rgba(244, 67, 54, 0.2), 0 1px 5px 0 rgba(244, 67, 54, 0.12)",
		"&:hover": {
			backgroundColor: dangerColor[0],
			boxShadow:
				"0 14px 26px -12px rgba(244, 67, 54, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(244, 67, 54, 0.2)",
		},
	},
	rose: {
		backgroundColor: roseColor[0],
		boxShadow:
			"0 2px 2px 0 rgba(233, 30, 99, 0.14), 0 3px 1px -2px rgba(233, 30, 99, 0.2), 0 1px 5px 0 rgba(233, 30, 99, 0.12)",
		"&:hover": {
			backgroundColor: roseColor[0],
			boxShadow:
				"0 14px 26px -12px rgba(233, 30, 99, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(233, 30, 99, 0.2)",
		},
	},
	white: {
		"&,&:focus,&:hover": {
			backgroundColor: "#FFFFFF",
			color: grayColor[0],
		},
	},
	simple: {
		color: "#FFFFFF",
		background: "transparent",
		boxShadow: "none",
	},
};

export default iconButtonStyle;
